module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/record-sleeve-49c77626e8ffa379175facd08127393f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/record-sleeve.svg
// module id = Bjwh
// module chunks = 24